import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

  //serviço usado para emitir a mensagem para outros componentes que precisem saber quando o usuário está logado ou não
  public isUserLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  //serviço usado para emitir a mensagem do header para a página gc-analisar-documentacao
  public idInscricaoSelecionada: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  
  
  constructor() { }

}
